/** @jsxImportSource @emotion/react */
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { useAppTheme } from '@hooks/useAppTheme';
import { deleteFieldVisitsPlanWithDexie } from '@services/local';
import { RootState } from '@state-mgmt/store';
import { styles } from './styles';

export interface Props {
  planId: number;
  onClose: (planId: number | undefined) => void;
}

const DeletePlanConfirmationModal = ({ planId, onClose }: Props) => {
  const { t } = useTranslation();
  const theme = useAppTheme({});
  const { themeMode } = useSelector((state: RootState) => state.app);

  return (
    <div css={styles.container(themeMode)}>
      <DialogTitle> {t('detele-plan-confirmation.title')}</DialogTitle>
      <DialogContent>
        <Typography css={styles.message}> {t('detele-plan-confirmation.text')}</Typography>
      </DialogContent>
      <DialogActions css={styles.actionsContainer(theme)}>
        <Button variant="outlined" onClick={() => onClose(undefined)} css={styles.actionsBtn}>
          {t('general.cancel')}
        </Button>
        <Button
          css={styles.actionsBtn}
          variant="contained"
          onClick={async () => {
            await deleteFieldVisitsPlanWithDexie(planId);
            onClose(planId);
          }}
        >
          {t('general.confirm')}
        </Button>
      </DialogActions>
    </div>
  );
};

export default DeletePlanConfirmationModal;
